<template>
	<div class="row">
        <div class="col-md-12">
            <div class="row">

                <div class="col-md-6 mb-4">
                    <div class="card border-start-success">
                        <div class="card-body px-3 py-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="me-2">
                                    <div class="text-success widget-title-card">{{ formatNum(totalAsset, 0) }}</div>
                                    <div class="card-text">Total Asset</div>
                                </div>
                                <div class="d-flex icon-circle text-success text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-s-platform"></i></div>
                            </div>
                        </div>
                    </div>					
                </div>

                <div class="col-md-6 mb-4">
                    <div class="card border-start-success">
                        <div class="card-body px-3 py-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="me-2">
                                    <div class="text-success widget-title-card">{{ formatNum(totalNilaiPerolehan, 0) }}</div>
                                    <div class="card-text">Total Nilai Perolehan</div>
                                </div>
                                <div class="d-flex icon-circle text-success text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-money"></i></div>
                            </div>
                        </div>
                    </div>					
                </div>

            </div>

            <div class="row">
                <div class="col-md-6 mb-4">
                    <el-card shadow="hover">
                        <div slot="header">
                            <h5 class="text-center m-0 px-2">Data Asset By Golongan</h5>
                        </div>
                        <div>
                            <table class="table-g" style="width:100%;">
                                <thead>
                                    <tr class="border-bottom">
                                        <th class="pb-2">Golongan</th>
                                        <th class="text-right">Jumlah</th>
                                        <th class="text-right">Nilai Perolehan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in reportdata?.data" :key="item.NamaGolongan">
                                        <td class="py-2">{{ item.NamaGolongan }}</td>
                                        <td class="text-right">{{ formatNum(item.CountData, 0) }}</td>
                                        <td class="text-right">{{ formatNum(item.NilaiPerolehan, 0) }}</td>
                                    </tr>
                                    <tr class="border-top">
                                        <td class="pt-3 fw-bold">Total</td>
                                        <td class="text-right font-weight-bold">{{ formatNum(totalAsset, 0) }}</td>
                                        <td class="text-right font-weight-bold">{{ formatNum(totalNilaiPerolehan, 0) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                    <Loader v-if="loading.table" />
                </div>
            </div>

        </div>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import { Rainbow, FuelColor, Penanggalan, AxiosWithJar, Config} from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Loader from '@/components/loader/Loader2.vue'
//import Footer from '@/views/Footer.vue'

export default{
	extends: Cafe,
	components:{
        Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//Footer            
	},
    props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        unitids: {
            type: Array,
            default() {
                return [];
            }
            //default: () => [],
            //required: false,
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: Penanggalan().bulan,
            //required: false,
        },
    },
    data() {
		return {
            //unitids : [],
            reportdata: [],
            loading: {
                table: false,
            },
		}
	},
    watch: {
        unitids() {
            this.getAssetOverview(); 
            //get data
            //console.log('unitids: ' + this.unitids);
        },
    },
    mounted()
	{
		//this.getAssetOverview();
    },
    computed: {
		totalAsset() {
			return this.reportdata?.data?.reduce((sum, item) => sum + parseFloat(item.CountData), 0);
		},
		totalNilaiPerolehan() {
			return this.reportdata?.data?.reduce((sum, item) => sum + parseFloat(item.NilaiPerolehan), 0);
		},
	},
    methods:{
        async getAssetOverview() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/nfr/assetoverview?'

			//this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&unitgroup='+this.unitids
			this.urlRequestParams+='&plant='+this.plant

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;

                    //console.log('this.reportdata' + JSON.stringify(this.reportdata["data"]))
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}

</script>

<style>

.border-start-primary {
	border-left: 5px solid #007BFF !important; /** card-raised border-start border-green border-5 */
}

.border-start-success {
	border-left: 5px solid #67C23A !important; /** card-raised border-start border-green border-5 */
}

.border-start-warning {
	border-left: 5px solid #E6A23C !important; /** card-raised border-start border-green border-5 */
}

.border-start-danger {
	border-left: 5px solid #F56C6C !important; /** card-raised border-start border-green border-5 */
}

.widget-icon {
	opacity: .3;
}
</style>